app.controller(
    'ConsultationController', ['$scope', '$rootScope', '$timeout', 'toastr', '$document', '$stateParams', 'NgMap', 'MapService', 'HelperService', '$translate', 'ChangeLogService', '$sce', '$state', ConsultationController]
);



function ConsultationController($scope, $rootScope, $timeout, toastr, $document, $stateParams, NgMap, MapService, HelperService, $translate, ChangeLogService, $sce, $state) {
    $rootScope.LayoutWithSearch = false;
    $scope.moduleState = 'list';
    $scope.first = false;
    $scope.second = false;
    $scope.show = true;
    $scope.free = false;
    $scope.ChangeDetails = [];
    $scope.currentChangeLog = [];
    $rootScope.isHistoryView = false;

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }

    $scope.ckOptions = {
        //forcePasteAsPlainText: true,
        language: 'fr',
        allowedContent: true,
        entities: false,
        disableAutoInline: true,
        toolbar: [
            {
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', 'Format', 'RemoveFormat', 'Paste', 'PasteText', '-', 'Undo', 'Redo', 'Subscript', 'Superscript']
            },
            {
                name: 'editing',
                items: ['Scayt']
            },
            {
                name: 'link',
                items: ['Link', 'UnLink', 'Anchor']
            },
            {
                name: 'insert',
                items: ['Image']
            },
            {
                name: 'list',
                items: ['NumberedList', 'BulletedList']
            },
            {
                name: 'source',
                items: ['Styles', 'Source']
            },
            {
                name: 'preview',
                items: ['Preview']
            }
        ],
        removeButtons: '',
        extraPlugins: 'preview',
        scayt_autoStartup: false
    };

    $scope.previsual = false;


    $scope.ckOptionsEditClient = {
        //forcePasteAsPlainText : true,

        language: 'fr',
        allowedContent: true,
        disableNativeSpellChecker: false,
        //convertLineEndings : true,
        //enterMode: 2,
        //autoParagraph: false,
        entities: false,
        basicEntities : false,
        //ignoreEmptyParagraph: true,
        toolbar: [
            {
                name: 'basicstyles',
                items: ['Bold', 'Italic', 'Underline', 'Format', 'RemoveFormat', 'Paste', 'PasteText', '-', 'Undo', 'Redo', 'Subscript', 'Superscript']
            },
            {
                name: 'editing',
                items: ['Scayt']
            },
            {
                name: 'link',
                items: ['Link', 'UnLink', 'Anchor']
            },
            {
                name: 'insert',
                items: ['Image']
            },
            {
                name: 'list',
                items: ['NumberedList', 'BulletedList']
            },
            {
                name: 'source',
                items: ['Styles', 'Source']
            },
            {
                name: 'preview',
                items: ['Preview']
            }
        ],
        removeButtons: 'liststyle,tabletools,scayt,menubutton,contextmenu',
        extraPlugins: 'preview',
        scayt_autoStartup: false,
        stylesSet: 'attributeStyleSet',
        //contentsCss: 'www/assets/css/main.css',
    };


    $scope.detailsSelection = [];

    $scope.classification = {};
    $scope.associations = {};
    $scope.lieu = {};
    $scope.contact = {};
    $scope.media = {};
    $scope.evenement = {};
    $scope.informations = {};

    /**Swipe edit sidepanel**/
    $scope.showDetail = function (page, big) {
        angular.element(document.getElementById('container-body')).addClass('sidenav__edit--is-open');
        if (big) {
            angular.element(document.getElementById('container-body')).addClass('sidenav__edit--is-open--big');
        }
        $timeout(
            function (event) {
                $scope.show = true;
            }
        );
        $scope.moduleState = page;
    };

    $scope.config = {
        // autoHideScrollbar: false,
        setHeight: 500,
    };


    /** Show previsual **/
    $scope.showPrevisual = function () {
        $scope.previsual = !$scope.previsual;
    };
    $scope.getHtml = function (htmlContent) {        
        return $sce.trustAsHtml(htmlContent);
    };
   
    /**
     * Simulation succes form
     * @method
     * @return {[type]} [description]
     */
    $scope.save = function (a, b) {
        $scope.information = a;
        $scope.room = b;
        toastr.success('L\'enregistrement a été effectué avec succès.');
        $scope.close();
    };

    /**
     * Close sidebar menu
     * @method
     * @return {[type]} [description]
     */
    $scope.close = function () {
        angular.element(document.getElementById('container-body')).removeClass('sidenav__edit--is-open').removeClass('sidenav__edit--is-open--big');
    };

    /**
     * Initialized Jquery
     * @type {Boolean}
     */
    $scope.$on(
        '$viewContentLoaded',
        function () {
            menu();
            tabs();
            $timeout(
                function () {
                    $scope.first = true;
                    $scope.show = false;
                    marginBottom();
                }, 100
            );

        }
    );

    /**
     * Show tabs visible
     * @method
     * @param  {[type]} tabs [description]
     * @return {[type]}      [description]
     */
    $scope.showTabs = function (tabs) {
        if (tabs === 'first') {
            $scope.first = true;
            $scope.second = false;
            ShowGmapsOnSideBar($rootScope.placevm.CurrentPlace.Xwgs84, $rootScope.placevm.CurrentPlace.Ywgs84, $rootScope.sideBarPlaceMap, 'sideBarPlaceMap', false, false);
        } else if (tabs === 'second') {
            $scope.first = false;
            $scope.second = true;
        }
        $timeout(
            function () {
                marginBottom();
            }, 100
        );
    };

    function marginBottom() {
        var last = angular.element(document.querySelector(".contenu_onglet:not(#contenu_onglet_third) .block-slide-right:last-child")),
            container = angular.element(document.querySelector('.contenu_onglet'));

        angular.element(window).bind('resize', function () {
            marginBottom();
        });

        if (typeof container[0] !== "undefined" && typeof last[0] !== "undefined" && container[0].offsetHeight && last[0].offsetHeight) {
            var res = container[0].offsetHeight - last[0].offsetHeight;
            container[0].style.paddingBottom = res + "px";
        }

    }

    /**
     * Select prev scrollbars
     * @method
     * @param  {[type]} container       [description]
     * @param  {[type]} containerActive [description]
     * @return {[type]}                 [description]
     */
    $scope.prev = function (container, containerActive) {
        var container = angular.element(document.getElementById(container));
        var containerActive = angular.element(document.getElementById(containerActive));
        var scrollspy = containerActive.find('.active').prev().attr('du-scrollspy');
        if (scrollspy != undefined) {
            var someElement = angular.element(document.getElementById(scrollspy));
            container.scrollTo(someElement, 0, 200);
        }
    };

    /**
     * Select next scrollbars
     * @method
     * @param  {[type]} container       [description]
     * @param  {[type]} containerActive [description]
     * @return {[type]}                 [description]
     */
    $scope.next = function (container, containerActive) {
        var container = angular.element(document.getElementById(container));
        var containerActive = angular.element(document.getElementById(containerActive));
        var scrollspy = containerActive.find('.active').next().attr('du-scrollspy');
        if (scrollspy != undefined) {
            var someElement = angular.element(document.getElementById(scrollspy));
            container.scrollTo(someElement, 0, 200);
        }
    };

    $scope.isTraductionMode = $state.$current.includes['app.traduction'];


    $scope.tarifGens = [
        {
            id: 1,
            openDropdown: false
        }
    ];

    $scope.periodes = [
        {
            id: 1
        }
    ];

    $scope.mouseDown = function load(id, lang) {
        $(".txt-error, .txt-green").addClass("yellow-highlight");
    }

    $scope.mouseUp = function load(id, lang) {
        $(".txt-error, .txt-green").removeClass("yellow-highlight");
    }

    /**
   * load change log
   */
    $scope.loadChangeLog = function load(id, objectType) {
        ChangeLogService.GetChangeLogById(id, objectType)
            .then(function (changelog) {

                var oldvalue = angular.fromJson(changelog.OldValue);
                var newvalue = angular.fromJson(changelog.NewValue);
                $scope.currentChangeLog = angular.fromJson(changelog);
                var keys = [];
                for (var k in oldvalue) keys.push(k);
                for (var k in newvalue) {
                    if ($.inArray(k, keys) == -1)
                        keys.push(k);
                }

                var changeDetails = [];
                for (var k in keys) {
                    var name = keys[k];
                    var item = {};

                    item["Name"] = name;
                    if (oldvalue[name] !== undefined)
                        item["OriginalValue"] = oldvalue[name];
                    else
                        item["OriginalValue"] = "";
                    if (newvalue[name] !== undefined)
                        item["NewValue"] = newvalue[name];
                    else
                        item["NewValue"] = "";

                    if (name == 'StatusId' || name=="ClientId") {
                        item["OriginalValue"] = name + item["OriginalValue"];
                        item["NewValue"] = name + item["NewValue"];
                    }

                    changeDetails.push(item);
                }
                $scope.ChangeDetails = changeDetails;
                //$scope.ChangeDetails = changelog.Description;
            });
    }

    /**
     * show change log
     */
    // [Lam Hong 18-May-2021] LVCG-36: [BO INTERFACE] List of previous updates on a content does not show correctly
    //$scope.showChangeLog = function (changeLogId) {
    //    $rootScope.isHistoryView = true;
    //    $scope.loadChangeLog(changeLogId, "Place");
    //};
    $scope.showChangeLog = function (changeLogId, objectType) {
        $rootScope.isHistoryView = true;
        $scope.loadChangeLog(changeLogId, objectType);
    };


    /**
     * show change log
     */
    $rootScope.hideChangeLog = function () {
        $rootScope.isHistoryView = false;
    };


    /**
     * add tarif general
     */
    $scope.addGenTarif = function () {
        var id = parseInt($rootScope.SideBar.SP.prices.length) + 1; // no need for id 
        $rootScope.SideBar.SP.prices.push({

            Id: 0,
            PubliCode: '******',
            Price: 0,
            WithCons: false,
            LinkTableId: 1,
            LinkTypeId: 1,
            CurrencyId: 1

        });
    };

    /**
     * Remove tarif (Tarif general)
     * @param tarif
     */
    $scope.removeGenTarif = function (tarif) {
        $rootScope.SideBar.SP.prices.splice(tarif, 1);
    };

    /**
     * Add new periode
     */
    $scope.addPeriode = function () {
        var nbItem = parseInt($rootScope.SideBar.SP.sections.length);
        var lastItem = $rootScope.SideBar.SP.sections[nbItem - 1];
        var id = (lastItem) ? lastItem.section.Id + 1 : nbItem + 1; // no need for id
        var sectioninit = {
            Id: 0,
            LinkTableID: 0,
            LinkTypeID: 0,
            BeginDate: '',
            EndDate: '',
            AllYear: false
        }
        var sectionsdetailinit = []

        $rootScope.SideBar.SP.sections.push({
            section: sectioninit,
            sectionsdetail: sectionsdetailinit

        });
    };

    /**
     * Remove periode
     * @param periode
     */
    $scope.removePeriode = function (periode) {
        $rootScope.SideBar.SP.sections.splice(periode, 1);
    };

    /**
     * Add a new "horaire" in "periode"
     * @param periode
     */
    $scope.addHoraireIn = function (periode) {

        if (!$rootScope.SideBar.SP.sections[periode].sectionsdetail) {
            $rootScope.SideBar.SP.sections[periode].sectionsdetail = [];
        }


        //    var nbItem = parseInt($rootScope.SideBar.SP.sections[periode].sectionsdetail.length);


        //  var lastItem = $rootScope.SideBar.SP.sections[periode].sectionsdetail[nbItem - 1];
        // var id = (lastItem) ? lastItem.sectiondetail.Id + 1 : nbItem + 1;//no need for id

        var sectiondetailinit = {
            Id: 0,
            BeginHour: new Date(2001, 0, 1, 1, 0, 0),
            EndHour: new Date(2001, 0, 1, 1, 0, 0),
            Monday: false,
            Tuesday: false,
            Wednesday: false,
            Thursday: false,
            Friday: false,
            Saturday: false,
            Sunday: false,
            DayFirst: false,
            DaySecond: false,
            DayThird: false,
            DayFourth: false,
            DayFifth: false,
            DayLast: false,
            LinkTableID: 0,
            LinkTypeID: 0,
            HideEndHour: false,

        }
        var pricesinit = []

        $rootScope.SideBar.SP.sections[periode].sectionsdetail.push({
            sectiondetail: sectiondetailinit,
            prices: pricesinit
        });
    };

    /**
     * Remove horaire
     * @param periode
     * @param horaire
     */
    $scope.removeHoraire = function (periode, horaire) {
        $rootScope.SideBar.SP.sections[periode].sectionsdetail.splice(horaire, 1);
    };

    /**
     * Add a new "tarif" in "horaire"
     * @param periode
     * @param horaire
     */
    $scope.addTarifIn = function (periode, horaire) {

        if (!$rootScope.SideBar.SP.sections[periode].sectionsdetail[horaire].prices) {
            $rootScope.SideBar.SP.sections[periode].sectionsdetail[horaire].prices = [];
        }

        $rootScope.SideBar.SP.sections[periode].sectionsdetail[horaire].prices.push({

            Id: 0,
            PubliCode: '******',
            Price: 0,
            WithCons: false,
            LinkTableId: 1,
            LinkTypeId: 1,
            CurrencyId: 1

        });
    };



    /**
     * Remove tarif
     * @param periode
     * @param horaire
     * @param tarif
     */
    $scope.removeTarif = function (periode, horaire, tarif) {
        $rootScope.SideBar.SP.sections[periode].sectionsdetail[horaire].prices.splice(tarif, 1);
    };


    /**
     * add details for select for side
     * @method
     * @return {[type]} [description]
     */
    $scope.addDetails = function () {
        if ($scope.detailsInput != "") {

            $scope.details.push(
                {
                    name: $scope.detailsInput,
                    checked: $scope.checked
                }
            )

            $scope.detailsInput = "";
        }
    };

    $scope.addClassificationPriority = function () {
        if ($scope.classification.priorityInput != "") {

            $scope.classification.priorities.push(
                {
                    name: $scope.classification.priorityInput,
                    checked: $scope.classification.checked
                }
            );

            $scope.classification.priorityInput = "";
        }
    };

    $scope.updateClassificationPriorityChecked = function (key) {
        $scope.classification.countPriority = 0;
        $scope.classification.priorities[key].checked = $scope.classification.priorities[key] == false ? true : false;
        $scope.classification.priorities.forEach(
            function (value) {
                if (value.checked) {
                    $scope.classification.countPriority++;
                }
            }
        );
    };

    /**
     * Update the current event
     * @method
     * @return {[type]} [description]
     */
    $scope.showEvent = function (event) {
        $scope.currentEvent = event;
    };

    $scope.UpdateCheckboxChecked = function (key) {


        $scope.count = 0;
        $scope.details[key].checked = $scope.details[key].checked == false ? true : false;
        $scope.details.forEach(
            function (value) {
                if (value.checked) {
                    $scope.count++;
                }
            }
        );
    };

    $scope.openExplorer = function () {
        $timeout(
            function () {
                angular.element('#fileInfoSource').trigger('click');
            }, 0, false
        );
    };

    $scope.addFile = function () {
        var files = angular.element("#fileInfoSource").get(0).files;
        $scope.uploadDragNDrop(files);
    };

    $scope.uploadDragNDrop = function (files) {
        for (var i = 0; i < files.length; i++) {
            var name = files[i].name;

            $scope.informations.files.push(
                {
                    name: name
                }
            );
        }
        $scope.$apply();
    };

    $scope.deleteFile = function (index) {
        $scope.informations.files.splice(index, 1);
    };
    $scope.dropdownDescIsOpen = false;

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.updateFieldTags = function () {
        $scope.$emit('updateFieldTags');
    };


    var marker = function () {
        return {
            city: '',
            dept: '',
            region: '',
            country: '',
            cp: '',
            precision: '',
            lat: '',
            lng: '',
            label: 'E'
        }
    };

    $scope.showTextOverMap = true;
    $scope.dataCity = [];
    $scope.mapInfo = "";

    $scope.markers = [];

    $scope.googleMarker = {};
    $scope.currentCenter = {};
    $scope.bingMarker = {};
    $scope.myMarker = {};
    $scope.lng = 2.3522219000000177;
    $scope.lat = 48.856614;
    $scope.currMarker = {};
    $scope.markers.push($scope.myMarker);
    $scope.markers.push($scope.googleMarker);
    $scope.markers.push($scope.bingMarker);

    $scope.addMarker = function (event) {
        var ll = event.latLng;

        $scope.myMarker = new marker();
        $scope.myMarker.lat = ll.lat();
        $scope.myMarker.lng = ll.lng();
        $scope.myMarker.label = 'M';

        $scope.markers[0] = $scope.myMarker;
    }

    $scope.setCenter = function (index) {
        $scope.lat = $scope.markers[index].lat;
        $scope.lng = $scope.markers[index].lng;
    }

    $scope.setlatlng = function (marker) {
        $rootScope.placevm.CurrentPlace.Xwgs84 = marker.lat;
        $rootScope.placevm.CurrentPlace.Ywgs84 = marker.lng;
    }

    $scope.fitBound = function () {
        var bounds = new google.maps.LatLngBounds();
        for (var i = 0; i < $scope.markers.length; i++) {
            if ($scope.markers[i].lat !== undefined && $scope.markers[i].lng !== undefined) {
                var latlng = new google.maps.LatLng($scope.markers[i].lat, $scope.markers[i].lng);
                bounds.extend(latlng);
            }
        }

        NgMap.getMap().then(function (map) {
            map.setCenter(bounds.getCenter());
            map.fitBounds(bounds);
        });
    }

    $scope.geocode = function () {
        var address = $rootScope.placevm.CurrentPlace.PlaceTranslationList[0].AddressLine + ', ' + $rootScope.placevm.CitySelected.name;
        $scope.get_results(address);
    }

    $scope.get_results = function (text) {
        MapService.getGoogleLocation(text).then(function (results) {
            var data = results[0];
            data.info = [];
            results[0].address_components.forEach(function (item) {
                data.info[item.types[0]] = item.long_name;
            });

            var m = new marker();
            m.city = data.info.locality;
            m.dept = data.info.administrative_area_level_2;
            m.region = data.info.administrative_area_level_1;
            m.country = data.info.country;
            m.cp = data.info.postal_code;
            m.lat = data.geometry.location.lat();
            m.lng = data.geometry.location.lng();
            m.latlng = data.geometry.location;
            m.label = 'G';

            $scope.googleMarker = m;
            $scope.markers[1] = $scope.googleMarker;

            $scope.fitBound();
            if ($scope.bingMarker.latlng !== undefined) {
                HelperService.GetDistance($scope.googleMarker.latlng, $scope.bingMarker.latlng).then(checkGetDistance);
            }
        });

        MapService.getBingLocation(text).then(function (results) {
            var data = results[0];

            var m = new marker();
            m.city = data.address.locality;
            m.dept = data.address.district;
            m.region = data.address.adminDistrict;
            m.country = data.address.countryRegion;
            m.cp = data.address.postalCode;
            m.lat = data.location.latitude;
            m.lng = data.location.longitude;
            m.latlng = data.location;
            m.label = 'B';

            $scope.bingMarker = m;
            $scope.markers[2] = $scope.bingMarker;

            $scope.fitBound();
            if ($scope.googleMarker.latlng !== undefined) {
                HelperService.GetDistance($scope.googleMarker.latlng, $scope.bingMarker.latlng).then(checkGetDistance);
            }
        });
    };

    function checkGetDistance(response) {
        var distanceInt = parseInt(response.data);
        if (distanceInt != NaN && distanceInt > 50) {
            toastr.error($translate.instant("place.incoherenceResultatCartographe").replace("{text}", distanceInt), '', {
                timeOut: 0,
                allowHtml: true
            });
        } else if (distanceInt == NaN) {
            toastr.options.timeOut = 0;
            toastr.error(response.data);
        }
    }

    $scope.mapOptions = {
        center: { latitude: 30.614919, longitude: -96.342316 },
        zoom: 6,
        mapType: 'a',
        options: {
            //disablePanning: true,
            //disableZooming:true
        }
    }; 


}